import MessagePanelContent from "./message-panel-content";

export default MessagePanelContent;